import { PRIMARY_DOMAIN } from '../config/networkDomains';

export const IOS_TESTFLIGHT_URL = 'https://testflight.apple.com/join/EEf5qCy6';
export const ANDROID_PACKAGE = 'com.tgkw.imflutter';
export const DOWNLOAD_CONFIG_URL = 'https://testapp.tgkw.com/app/config.json';
export const DOWNLOAD_PAGE_URL = `https://${PRIMARY_DOMAIN}/#download`;

/** Opens the installed Huawei AppGallery by package. Other stores are no longer listed. */
export const HUAWEI_MARKET_URL = `appmarket://details?id=${ANDROID_PACKAGE}`;

export type ReleaseFile = {
  name?: string;
  version?: string;
  desc?: string;
  domain?: string;
  path?: string;
  time?: number;
  size?: number;
};

export type DownloadCatalog = {
  ipaList?: ReleaseFile[];
  apkList?: ReleaseFile[];
  appList?: ReleaseFile[];
};

export function isHuaweiDevice(userAgent: string): boolean {
  if (/HONOR/i.test(userAgent)) return false;
  return /HuaweiBrowser|HUAWEI|HarmonyOS|OpenHarmony/i.test(userAgent);
}

export function latestProduction(
  items: ReleaseFile[] | undefined,
  accept: (item: ReleaseFile) => boolean,
): ReleaseFile | undefined {
  return (items || [])
    .filter((item) => accept(item) && (item.desc || '').includes('正式环境'))
    .reduce<ReleaseFile | undefined>((best, item) => {
      if (!best || (item.time || 0) > (best.time || 0)) return item;
      return best;
    }, undefined);
}

export function fileUrl(item?: ReleaseFile): string {
  if (!item?.domain || !item.path || !item.name) return '';
  return `${item.domain}${item.path}${item.name}`;
}

export function formatFileSize(size?: number): string {
  if (!size) return '';
  if (size > 1024 * 1024) return `${(size / 1024 / 1024).toFixed(1)} MB`;
  if (size > 1024) return `${(size / 1024).toFixed(1)} KB`;
  return `${size} B`;
}

export type AndroidInstallChoice = {
  href: string;
  label: string;
};

export function androidInstallChoice(userAgent: string, apkUrl: string): AndroidInstallChoice {
  if (isHuaweiDevice(userAgent)) {
    return { href: HUAWEI_MARKET_URL, label: '商店下载' };
  }
  return { href: apkUrl, label: '立即下载' };
}

/** Release notes from the catalog, without the environment marker. */
export function releaseNotes(desc?: string): string {
  return (desc || '')
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line && line !== '正式环境' && line !== '测试环境')
    .join('\n');
}
